// ! [dependencies] Import all dependencies.

// Babel

import 'babel-polyfill';

// jQuery and Bootstrap.

import jQuery from 'jquery';
import Popper from 'popper.js';
import Meta from 'vue-meta'

global.jQuery = jQuery;
global.$      = jQuery;
global.Popper = Popper;

var Bootstrap = require ( 'bootstrap' );


// VueJS related.

import Vue       from 'vue';
import Vuex      from 'vuex';
import VueRouter from 'vue-router';
import VueBreadcrumbs from 'vue-breadcrumbs';
import VuePaginate from 'vue-paginate';
import VueValidate from 'simple-vue-validator';
import datePicker from 'vue-bootstrap-datetimepicker';
import AsyncComputed from 'vue-async-computed';


// Configure Axios as a global variable.

import Axios from 'axios';

global.axios = Axios;


// Application related.

import App          from './App.js';
import _App         from '../custom/_App.vue';
import _Controllers from '../custom/_Controllers.js';
import _Routes      from '../custom/_Routes.js';
	

// ! [dependencies] Initialize all dependencies.

Vue.use ( Vuex );
Vue.use ( VueRouter );
Vue.use ( VueBreadcrumbs );
Vue.use ( VuePaginate );
Vue.use ( VueValidate );
Vue.use ( datePicker );
Vue.use ( AsyncComputed );
Vue.use(Meta)




// ! [axios] Configure axios.
	
Axios.defaults.baseURL = process.env.ENDPOINT;


// ! [route] Configure routing.

const router = new VueRouter ( { 
								mode: 'history', 
								routes: _Routes.routes, 
								linkActiveClass: 'active' 
							});
// const router = new VueRouter ({
// 							routes: _Routes.routes,
// 							linkActiveClass: 'active'
// 						});
router.afterEach(function (to, from, next) {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 0);
    // next();
});


// ! [vuex] Configure the Vuex store.


// Pull restricted controllers.

import Auth from './Auth.js';
import Support from './Support.js';

_Controllers.modules.auth = Auth;
_Controllers.modules.support = Support;


// Pull custom constrollers.

import _Access   from '../custom/_Access.js';

_Controllers.modules.access = _Access;


// Initialize the store.

const store = new Vuex.Store ( _Controllers );
	

// ! [execute] Start Vue application.
Vue.config.devtools = true;


new Vue ( {
	
	router,
	store,
	
	el: '#app',
	
	mixins: [App],
	
	render: h => h ( _App )
	
} );



// WEBPACK FOOTER //
// ./src/restricted/main.js